import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

// Components
import { ProductViewComponent } from './components/product-view/product-view.component';
import { ProductComingSoonComponent } from './modals/product-coming-soon/product-coming-soon.component';
// Services
import { ProductEffects } from './store/product.effects';

import { UiMspotModule } from '@features/mspot/mspot.module';
import { ProductsFeatureModule } from '@features/products/product/product-feature.module';
import { ProductsArrayFeatureCoreModule } from '@features/products/productsArray/productsArray-feature.core.module';
import { MapService } from '@shared/map/map.service';
import { PricesModule } from '@shared/prices/prices.module';
import { LazyLoadService } from '@shared/services/lazy-load.service';
import { DialogModule } from '@ui/dialog/dialog.module';

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        PricesModule,
        ProductComingSoonComponent,
        ProductsArrayFeatureCoreModule,
        ProductsFeatureModule,
        TranslateModule.forChild(),
        ProductViewComponent,
        SwiperModule,
        UiMspotModule,
    ],
    providers: [
        provideEffects(ProductEffects),
        LazyLoadService,
        MapService,
    ],
})
export class ProductModule {}
